// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable babel/camelcase */
import { PLACE_TYPES } from "../../consts/place"

export const locationToPlaceTypes = {
  city: PLACE_TYPES.CITY,
  subdivision: PLACE_TYPES.COUNTRY, // subdivision is most similar to country TODO on native use of locations use normal subdivisions
  autonomous_territory: PLACE_TYPES.AUTONOMOUS_TERRITORY,
  country: PLACE_TYPES.COUNTRY,
  airport: PLACE_TYPES.AIRPORT,
  station: PLACE_TYPES.TRAIN_STATION,
  bus_station: PLACE_TYPES.BUS_STATION,
  region: PLACE_TYPES.REGION,
  continent: PLACE_TYPES.CONTINENT,
  special: PLACE_TYPES.SPECIAL,
} as const

export const placeToLocationTypes = {
  [PLACE_TYPES.CITY]: "city",
  [PLACE_TYPES.AUTONOMOUS_TERRITORY]: "autonomous_territory",
  [PLACE_TYPES.COUNTRY]: "country",
  [PLACE_TYPES.AIRPORT]: "airport",
  [PLACE_TYPES.TRAIN_STATION]: "station",
  [PLACE_TYPES.BUS_STATION]: "bus_station",
  [PLACE_TYPES.REGION]: "region",
  [PLACE_TYPES.CONTINENT]: "continent",
  [PLACE_TYPES.SPECIAL]: "special",
} as const
